import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const LoaderNotes = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box style={{
      display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', gap: '5px'
    }}
    >
      <Typography>{t('common:loading')}</Typography>
      <CircularProgress
        thickness={2}
        style={{ color: theme.accent.main }}
      />
    </Box>
  );
};